import { noop } from 'lodash-es'
import { createContext, useState, useMemo, type FC, type PropsWithChildren } from 'react'
import { useIsomorphicLayoutEffect } from '@react-hookz/web'

interface BusinessIdContext {
  businessId: string | null
  setBusinessId: (businessId: string) => void
}

export const BusinessIdContext = createContext<BusinessIdContext>({
  businessId: null,
  setBusinessId: noop,
})

interface BusinessIdProviderProps {
  businessId: BusinessIdContext['businessId']
}

export const BusinessIdProvider: FC<PropsWithChildren<BusinessIdProviderProps>> = ({ children, ...props }) => {
  const [businessId, setBusinessId] = useState(props.businessId)

  useIsomorphicLayoutEffect(() => {
    setBusinessId(props.businessId)
  }, [props.businessId])

  const value = useMemo(() => ({ businessId, setBusinessId }), [businessId, setBusinessId])

  return <BusinessIdContext.Provider value={value}>{children}</BusinessIdContext.Provider>
}
